import { render, staticRenderFns } from "./AisTarget.vue?vue&type=template&id=cce24b16&"
import script from "./AisTarget.vue?vue&type=script&lang=ts&"
export * from "./AisTarget.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports